import React, { useState } from 'react';
import { ArrowRight, Facebook, Instagram, Linkedin, Mail, MapPin, Phone, Twitter } from 'lucide-react';
import "./Footer.css";
import { Link } from 'react-router-dom';
import { FiMapPin } from 'react-icons/fi';

const Footer = () => {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    const navigationLinks = [
        { name: 'Home ', href: '/' },
        { name: 'About', href: '/About' },
        { name: 'Service', href: '/Service' },
        { name: 'Career', href: '/Career' },
        { name: 'Portfolio', href: '/Portfolio' },
        { name: 'Contact', href: '/Contact' },
    ];

    const socialLinks = [
        { icon: Facebook, href: 'https://www.facebook.com/share/16rVuK4knh/?mibextid=wwXIfr', label: 'Facebook' },
        { icon: Instagram, href: 'https://www.instagram.com/dynamicsoftlink?igsh=MXN4YjRxOHVlcGVuYw==', label: 'Instagram' },
        { icon: Linkedin, href: 'https://www.linkedin.com/company/dynamic-softlink-pvt-ltd/', label: 'LinkedIn' },
        { icon: Twitter, href: 'https://x.com/dynamicsoftlink?s=21', label: 'Twitter' }
    ];

    const handleSubscribe = (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setMessage('');

        if (email.trim() === '') {
            setMessage('Please enter a valid email address.');
            setIsSubmitting(false);
            return;
        }

        // Simulating an API call to a newsletter service
        console.log(`Subscribing with email: ${email}`);

        setTimeout(() => {
            setMessage('Thank you for subscribing! 🎉');
            setEmail('');
            setIsSubmitting(false);
        }, 1500);
    };

    return (
        <div className="bg-[#0F0D1D]">
            <footer className="relative overflow-hidden bg_image_footer">
                {/* Background Pattern */}
                <div className="absolute inset-0 opacity-10">
                    <div className="absolute top-10 left-10 w-32 h-32 border border-blue-500 rounded-full"></div>
                    <div className="absolute top-20 right-20 w-24 h-24 border border-purple-500 rounded-full"></div>
                    <div className="absolute bottom-20 left-1/4 w-16 h-16 border border-blue-400 rounded-full"></div>
                    <div className="absolute bottom-10 right-10 w-20 h-20 border border-purple-400 rounded-full"></div>
                </div>

                {/* Main Footer Content */}
                <div className="relative z-10 containers mx-auto px-4 py-16 lg:py-20">
                    <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">

                        {/* Company Info */}
                        <div className="lg:col-span-1 space-y-6">
                            {/* Logo */}
                            <div className="flex items-center space-x-3">
                                <div className="flex items-center Main_logo space-x-2">
                                    <img src={require('../../Img/MainLogo1.png')} alt="" className="object-fit-contain" />
                                </div>
                            </div>
                            {/* Description */}
                            <p className="text-gray-400 leading-relaxed">
                                Empowering global businesses through next-gen digital products, modern UX, and scalable IT solutions. 
                            </p>
                            {/* Contact Info */}
                            <div className="space-y-4">
                                <div className="flex items-center space-x-3">
                                    <Phone className="w-5 h-5 text-blue-400" />
                                    <a href="tel:+919825131393" className="text-gray-300">
                                        <span>(+91)9825131393</span>
                                    </a>
                                </div>
                                <div className="flex items-center space-x-3">
                                    <Mail className="w-5 h-5 text-blue-400" />
                                    <a href="mailto:info@dynamicsoftlink.com" className="text-gray-300">
                                        info@dynamicsoftlink.com
                                    </a>
                                </div>
                                <div className="flex items-start space-x-3">
                                    <FiMapPin className=" text-blue-400 mt-1 text-5xl" />
                                    <span className="text-gray-300">402, Empire State Building, Near Udhna Darwaja, Ring Road, Surat 395002</span>
                                </div>
                            </div>
                        </div>

                        {/* Navigation */}
                        <div className="space-y-6">
                            <h3 className="text-xl font-semibold text-white">Our Navigation</h3>
                            <ul className="space-y-4">
                                {navigationLinks.map((link, index) => (
                                    <li key={index}>
                                        <a
                                            href={link.href}
                                            className="text-gray-300 hover:text-white transition-colors duration-200"
                                        >
                                            {link.name}
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </div>

                        {/* Subscribe Section with Functionality */}
                        {/* Note: This section now takes the place of the Instagram section */}
                        <div className="lg:col-span-2 space-y-6">
                            <h3 className="text-xl font-semibold text-white">Subscribe</h3>
                            <form onSubmit={handleSubscribe} className="space-y-4">
                                <div className="relative">
                                    <input
                                        type="email"
                                        placeholder="Get News & Updates"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        required
                                        className="w-full bg-gray-800 border border-gray-700 rounded-lg px-4 py-3 text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent pr-12"
                                    />
                                    <button
                                        type="submit"
                                        disabled={isSubmitting}
                                        className="absolute right-2 top-1/2 transform -translate-y-1/2 bg-[#1C74BB] text-white p-2 rounded-md transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                                    >
                                        <ArrowRight className="w-4 h-4" />
                                    </button>
                                </div>
                                {message && (
                                    <p className={`text-sm ${message.includes('Thank you') ? 'text-green-400' : 'text-red-400'}`}>
                                        {message}
                                    </p>
                                )}
                            </form>

                            {/* Description */}
                            <p className="text-gray-400 text-sm leading-relaxed">
                                Our expertise, as well as our passion for web design, sets us apart from other agencies
                            </p>

                            {/* Social Links */}
                            <div className="flex space-x-4">
                                {socialLinks.map((social, index) => {
                                    const IconComponent = social.icon;
                                    return (
                                        <a
                                            key={index}
                                            href={social.href}
                                            className="w-10 h-10 bg-gray-800 hover:bg-blue-600 rounded-lg flex items-center justify-center transition-all duration-200 hover:scale-110"
                                            aria-label={social.label}
                                        >
                                            <IconComponent className="w-5 h-5 text-gray-400 hover:text-white" />
                                        </a>
                                    );
                                })}
                            </div>

                        </div>
                    </div>
                </div>

                {/* Bottom Bar */}
                <div className="relative z-10 border-t border-gray-800">
                    <div className="container mx-auto px-4 py-6">
                        <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
                            <p className="text-gray-400 text-sm">
                                © 2025 DYNAMIC SOFTLINK. All rights reserved.
                            </p>
                            <div className="flex space-x-6 text-sm">
                                <Link onClick={() => window.scrollTo(0, 0)} to={'/PrivacyPolicy'} className="text-gray-400 hover:text-white transition-colors">Privacy Policy</Link>
                                <Link onClick={() => window.scrollTo(0, 0)} to={'/TermsOfService'} className="text-gray-400 hover:text-white transition-colors">Terms of Service</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    );
};

export default Footer;